import { DataTable } from '../../components/admin/data-table';
import { DateField } from '../../components/admin/date-field';
import { ImageField } from '../../components/admin/image-field';
import { ReferenceArrayField } from '../../components/admin/reference-array-field';
import { ReferenceField } from '../../components/admin/reference-field';
import { MoonstarList } from '../Moonstar/MoonstarList';
import { MoonstarListActions } from '../Moonstar/MoonstarListActions';
import { UserDisplayNameField } from '../User/UserDisplayNameField';
import { NudgeActions } from './NudgeActions';
import { NudgesReportEmailButton } from './NudgesReportEmailButton';
import { ReferenceCountPill } from './ReferenceCountPill';

export const NudgeList = () => {
  return (
    <MoonstarList
      sort={{ field: 'createdOn', order: 'DESC' }}
      actions={
        <MoonstarListActions>
          <NudgesReportEmailButton />
        </MoonstarListActions>
      }
    >
      <DataTable rowClick="edit" bulkActionButtons={false}>
        <DataTable.Col
          source="image.src"
          disableSort
          className="w-px whitespace-nowrap"
        >
          <ImageField
            source="image.src"
            title="image.title"
            className="block w-40 [&_img]:h-24 [&_img]:w-full [&_img]:rounded-md [&_img]:object-contain"
          />
        </DataTable.Col>
        <DataTable.Col source="title" />
        <DataTable.Col source="categoryIds" disableSort>
          <ReferenceArrayField
            source="categoryIds"
            reference="nudgeCategories"
            render={({ data }) => (
              <ReferenceCountPill records={data} noun="categories" />
            )}
          />
        </DataTable.Col>
        <DataTable.Col source="assigneeGroupIds" disableSort>
          <ReferenceArrayField
            source="assigneeGroupIds"
            reference="user-groups"
            render={({ data }) => (
              <ReferenceCountPill records={data} noun="groups" />
            )}
          />
        </DataTable.Col>
        <DataTable.Col source="userGroupIds" disableSort>
          <ReferenceArrayField
            source="userGroupIds"
            reference="user-groups"
            render={({ data }) => (
              <ReferenceCountPill records={data} noun="groups" />
            )}
          />
        </DataTable.Col>
        <DataTable.Col source="assignDateTime">
          <DateField source="assignDateTime" showTime empty="—" />
        </DataTable.Col>
        <DataTable.Col source="dueDateTime">
          <DateField source="dueDateTime" showTime empty="—" />
        </DataTable.Col>
        <DataTable.Col source="createdById" disableSort>
          <ReferenceField source="createdById" reference="users" link={false}>
            <UserDisplayNameField />
          </ReferenceField>
        </DataTable.Col>
        <DataTable.Col source="createdOn">
          <DateField source="createdOn" empty="—" />
        </DataTable.Col>
        <DataTable.Col className="w-px whitespace-nowrap">
          <NudgeActions />
        </DataTable.Col>
      </DataTable>
    </MoonstarList>
  );
};
